import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, Redirect } from 'react-router-dom';
import { getInt } from 'utils/functions';
import StateTransitionsContainer from 'features/document/edit/stateTransitions/components/StateTransitionsContainer';
import DocumentComments from 'features/offer/edit/sidebar/components/comments/DocumentComments';
import PartnerFileContainer from 'features/partnerFile/edit/states/components/PartnerFileContainer';
import OfferDocumentsContainer from 'components/offer/edit/documents/OfferDocumentsContainer';
import WorkflowContainer from 'components/offer/edit/workflow/components/WorkflowContainer';
import documentTypeIds from 'constants/documentTypeIds';
import WrappedFakeText from 'components/common/WrappedFakeText';
import DocumentUploadPreviewModal from 'features/document/edit/documents/components/DocumentUploadPreviewModal';
import PartnerFileBulkContainer from 'features/partnerFile/bulk/PartnerFileBulkContainer';

const PartnerFileSwitcher = ({ history, changeIndex, setChangeIndex }) => (
  <Switch>
    <Route exact path='/partner-files' render={() => <WrappedFakeText onPaper />} />
    <Route
      exact
      path='/partner-files/:newPartnerFile(new)'
      render={() => <PartnerFileContainer history={history} changeIndex={changeIndex} setChangeIndex={setChangeIndex} />}
    />
    <Route exact path='/partner-files/:newBulkFile(new-bulk)' render={() => <PartnerFileBulkContainer history={history} />} />
    <Route
      exact
      path='/partner-files/:documentId(\d+)/:siteId(\d+)'
      render={route => (
        <PartnerFileContainer
          documentId={getInt(route.match.params.documentId)}
          siteId={getInt(route.match.params.siteId)}
          history={history}
          changeIndex={changeIndex}
          setChangeIndex={setChangeIndex}
        />
      )}
    />
    <Route
      exact
      path='/partner-files/:documentId(\d+)/:siteId(\d+)/partner/:partnerId(\-?\d+)'
      render={route => (
        <PartnerFileContainer
          documentId={getInt(route.match.params.documentId)}
          siteId={getInt(route.match.params.siteId)}
          partnerId={getInt(route.match.params.partnerId)}
          history={history}
          changeIndex={changeIndex}
          setChangeIndex={setChangeIndex}
        />
      )}
    />
    <Route
      exact
      path='/partner-files/:documentId(\d+)/:siteId(\d+)/documents'
      render={route => (
        <OfferDocumentsContainer
          documentId={getInt(route.match.params.documentId)}
          siteId={getInt(route.match.params.siteId)}
          history={history}
        />
      )}
    />
    <Route
      exact
      path='/partner-files/:documentId(\d+)/:siteId(\d+)/documents/:fileId([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})'
      render={route => <DocumentUploadPreviewModal fileId={route.match.params.fileId} open={true} openFromRoute={true} />}
    />
    <Route
      exact
      path='/partner-files/:documentId(\d+)/:siteId(\d+)/workflows'
      render={route => <WorkflowContainer documentId={getInt(route.match.params.documentId)} siteId={getInt(route.match.params.siteId)} />}
    />
    <Route
      exact
      path='/partner-files/:documentId(\d+)/:siteId(\d+)/state-transitions'
      render={route => (
        <StateTransitionsContainer
          documentId={getInt(route.match.params.documentId)}
          siteId={getInt(route.match.params.siteId)}
          documentTypeId={documentTypeIds.PartnerFile}
        />
      )}
    />
    <Route
      exact
      path='/partner-files/:documentId(\d+)/:siteId(\d+)/comments'
      render={route => (
        <DocumentComments
          documentId={getInt(route.match.params.documentId)}
          siteId={getInt(route.match.params.siteId)}
          history={history}
          fullScreen={true}
        />
      )}
    />
    <Route render={() => <Redirect to='/notFound' />} />
  </Switch>
);

PartnerFileSwitcher.propTypes = {
  history: PropTypes.object.isRequired,
  changeIndex: PropTypes.number.isRequired,
  setChangeIndex: PropTypes.func.isRequired
};

export default PartnerFileSwitcher;
